import { render, staticRenderFns } from "./gameview.vue?vue&type=template&id=220b9828&scoped=true&"
import script from "./gameview.vue?vue&type=script&lang=js&"
export * from "./gameview.vue?vue&type=script&lang=js&"
import style0 from "./gameview.vue?vue&type=style&index=0&id=220b9828&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220b9828",
  null
  
)

export default component.exports